export const firebaseConfig = {
  apiKey: "AIzaSyDH7HTF7bl-TwQnWX6vYVaPZLEA0ib03Wg",
  authDomain: "card-grading.firebaseapp.com",
  projectId: "card-grading",
  storageBucket: "card-grading.appspot.com",
  messagingSenderId: "684508311396",
  appId: "1:684508311396:web:b9cc6ff1f6bb61dadbd471",
  measurementId: "G-YN59T05LQP",
};
